const $ = jQuery;

const elementGeometry = (el, viewportGeometry, prev, next) => {
    el = $(el);

    const position = el.offset();

    if (!el || !position || !position.left) {
        return false;
    }

    const size = {
        width: el.width(),
        height: el.height(),
        outerWidth: el.outerWidth(true),
        outerHeight: el.outerHeight(true),
    };

    position.right = position.left + size.width;
    position.outerRight = position.left + size.outerWidth;
    position.bottom = position.top + size.height;
    position.outerBottom = position.top + size.outerHeight;

    const clone = el.next('is-sticky-clone');

    return {
        el,
        clone,
        position,
        size,

        viewport: viewportGeometry,

        visible: position.top > viewportGeometry.scrollTop && position.bottom < viewportGeometry.scrollBottom,
        going_outside_top: position.top < viewportGeometry.scrollTop && position.bottom < viewportGeometry.scrollBottom,
        going_outside_bottom: position.top > viewportGeometry.scrollTop && position.bottom > viewportGeometry.scrollBottom,
        outside: position.bottom < viewportGeometry.scrollTop || position.top > viewportGeometry.scrollBottom,
        after_fold: viewportGeometry.scrollTop > position.bottom,

        prev,
        next
    };
}
const elementsGeometry = (elements, viewportGeometry) => $.makeArray(elements
    .map((i, el) => elementGeometry(
        el,
        viewportGeometry,
        i === 0 ? null : elements[i - 1],
        i === elements.length - 1 ? null : elements[i + 1]
    )).filter((i, item) => item !== false));

export {elementsGeometry, elementGeometry}
